import SvgIcon from '@mui/material/SvgIcon'

const ShareIcon = props => (
  <SvgIcon viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M13.86 8.405c.164-.14.245-.21.275-.292a.333.333 0 0 0 0-.226c-.03-.083-.111-.152-.274-.292l-5.647-4.84c-.28-.24-.42-.36-.54-.364a.333.333 0 0 0-.266.123c-.075.092-.075.277-.075.646v2.863A6.444 6.444 0 0 0 2 12.367v.408a7.6 7.6 0 0 1 5.333-2.728v2.793c0 .37 0 .554.075.646.065.08.164.125.267.122.119-.003.259-.123.539-.363l5.647-4.84z"
      stroke="#667085"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)
export default ShareIcon
